<script setup lang="ts">
import { computed } from "vue"

const { text, style } = defineProps({
  text: { type: String, required: true },
  style: { type: String, required: true },
})

const styleClass = computed(() => {
  return `text-bg-${style}`
})
</script>

<template>
  <span class="badge" :class="styleClass">{{ text }}</span>
</template>

<style scoped></style>
